import { service } from "@ember/service";
import { Ability } from "ember-can";
import type MedicModel from "parog-web/models/medic";
import type SemeiaSessionService from "parog-web/services/session";

/**
 * Classic Ember class is used there because ability overload in parog does not
 * otherwise. The bug is not completely identified though.
 *
 * Note that Ability properties must be computed properties.
 * https://github.com/minutebase/ember-can/issues/83
 */

interface MedicLike {
  role: string;
}

export default class MedicAbility extends Ability {
  @service declare session: SemeiaSessionService;

  canCreate(medicToCreate?: MedicLike): boolean {
    // Make sure a medic is logged in
    const creatorRole = this.session.medic?.role;
    if (!creatorRole) return false;

    // Make sure the logged in medic's role has some creatableRoles
    const creatableRoles = this.creatableRoles[creatorRole];
    if (!creatableRoles) return false;

    // if no model was passed to `canCreate`, then OK, the logged in medic CAN create
    if (!medicToCreate) return true;

    // if a model was passed to `canCreate`, make sure the creatableRoles roles contain this medic's role
    return creatableRoles.includes(medicToCreate.role);
  }

  get creatableRoles() {
    if (this.session.medic?.therapeuticalArea?.id == "rhumato")
      return { doctor: ["doctor", "nurse"], nurse: ["nurse"] };

    return {
      doctor: ["doctor", "nurse", "medical_secretary"],
      nurse_lead: ["nurse", "medical_secretary"],
      nurse: ["nurse", "medical_secretary"],
      medical_secretary: ["medical_secretary"]
    };
  }

  get canList(): MedicModel | undefined {
    return this.session.medic;
  }

  get canEdit(): boolean | undefined {
    return this.session.medic && this.session.medic.role === "doctor";
  }
}
